import {Validators} from '@angular/forms';

import {FinancialQuestionnaireTypesEnum} from '@spa/api';

import {Helper, SelectControl} from '../../../app/shared/classes';
import {ComponentTypesEnum} from '../../../app/shared/enums';

export const AnnualNetIncomeSelector = FinancialQuestionnaireTypesEnum.AnnualNetIncome;
export const AnnualNetIncomeCurrencySelector = `${FinancialQuestionnaireTypesEnum.AnnualNetIncome}-currency`;
export const EstimatedNetWorthSelector = FinancialQuestionnaireTypesEnum.EstimatedNetWorth;
export const EstimatedNetWorthCurrencySelector = `${FinancialQuestionnaireTypesEnum.EstimatedNetWorth}-currency`;
export const IntendedInvestmentAmountSelector = FinancialQuestionnaireTypesEnum.AmountIntendedToInvest;
export const AmountIntendedToInvestCurrencySelector = `${FinancialQuestionnaireTypesEnum.AmountIntendedToInvest}-currency`;

export const EstimatedWorthControls = (): SelectControl[] => {
    return [
        new SelectControl({
            name: AnnualNetIncomeSelector,
            value: null,
            placeholder: 'Annual net income',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: AnnualNetIncomeCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [...Helper.getCurrencyOptions()],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: EstimatedNetWorthSelector,
            value: null,
            placeholder: 'Estimated net worth',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: EstimatedNetWorthCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [...Helper.getCurrencyOptions()],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: IntendedInvestmentAmountSelector,
            value: null,
            placeholder: 'Intended investment Amount',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: AmountIntendedToInvestCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [...Helper.getCurrencyOptions()],
            floatingLabelNever: true
        })
    ];
};
